<div class="d-flex flex-column justify-content-center align-items-center w-100 min-vh-100">
    <div class="continuous-loader" role="status"></div>
    <h4 class="mt-2">{{dataToDisplay}}</h4>
</div>